import { render, staticRenderFns } from "./DistrictSelector.vue?vue&type=template&id=4d6845cd&scoped=true"
import script from "./DistrictSelector.vue?vue&type=script&lang=js"
export * from "./DistrictSelector.vue?vue&type=script&lang=js"
import style0 from "./DistrictSelector.vue?vue&type=style&index=0&id=4d6845cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6845cd",
  null
  
)

export default component.exports